module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousDailyVehicleTrackView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Daily Vehicle Track Details")])], 1), _vm._v(" "), _c('b-card', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": _vm.dateRange.startDate ? '25' : '15'
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "w-100 text-center mt-3"
  }, [_c('b-button', {
    staticClass: "Mobile-Btn",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3 Mobile-Btn",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")]), _vm._v(" "), (_vm.customVehicleTrack == true ? true : false) ? _c('b-button', {
    staticClass: "ml-3 Mobile-Btn",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getCustomIdelVehicleListDetails()
      }
    }
  }, [_vm._v("Idle Vehicle List")]) : _vm._e(), _vm._v(" "), (_vm.customVehicleTrack == true ? true : false) ? _c('b-button', {
    staticClass: "ml-3 Mobile-Btn",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export Idle Vehicle List' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getCustomIdelVehicleList('CustomIdelVehicleList_SCREEN', '', 'Export Idle Vehicle List')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExcelBtnName) + "\n                "), (_vm.ExcelBtnName != 'Export Idle Vehicle List') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3 Mobile-Btn",
    attrs: {
      "disabled": _vm.DailyExcelBtnName != 'Export Daily Idle Vehicle Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getCustomIdelVehicleList('DailyVehicleTrack_SCREEN', '', 'Export Daily Idle Vehicle Excel')
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.DailyExcelBtnName) + "\n                "), (_vm.DailyExcelBtnName != 'Export Daily Idle Vehicle Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [_c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-3"
  }, [(_vm.veiwVehicleMaster.length > 0) ? _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.veiwVehicleMaster,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "sr_no",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "tot_vehicle",
      fn: function(row1) {
        return [_c('b', [_vm._v(_vm._s(row1.item.tot_vehicle))])]
      }
    }, {
      key: "tot_bookedGR",
      fn: function(row2) {
        return [(row2.index == 0) ? _c('b-button', {
          attrs: {
            "variant": "outline-danger",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.showDailyVehicleDeatils(row2.item, 'tot_bookedGR')
            }
          }
        }, [_c('b', [_vm._v(_vm._s(row2.item.tot_bookedGR))])]) : _c('b', [_vm._v(_vm._s(row2.item.tot_bookedGR))])]
      }
    }, {
      key: "tot_avilable",
      fn: function(row3) {
        return [(row3.index == 0) ? _c('b-button', {
          attrs: {
            "variant": "outline-success",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.showDailyVehicleDeatils(row3.item, 'tot_avilable')
            }
          }
        }, [_c('b', [_vm._v(_vm._s(row3.item.tot_avilable))])]) : _c('b', [_vm._v(_vm._s(row3.item.tot_avilable))])]
      }
    }, {
      key: "tot_inactive",
      fn: function(row4) {
        return [_c('b', [_vm._v(_vm._s(row4.item.tot_inactive))])]
      }
    }, {
      key: "vehicle_log_date",
      fn: function(row5) {
        return [_c('b-button', {
          attrs: {
            "variant": "outline-primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.showDailyIdelVehicleList(row5.item)
            }
          }
        }, [_c('b', [_vm._v(_vm._s(row5.item.vehicle_log_date))])])]
      }
    }])
  }) : _vm._e(), _vm._v(" "), (_vm.IdelVehicleList.length > 0) ? _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.IdelVehicleList,
      "fields": _vm.fields1,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "sr_no",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "vehicleNo",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.vehicleNo))]
      }
    }, {
      key: "mainSalesSeries",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.mainSalesSeries))]
      }
    }, {
      key: "clientName",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.clientName))]
      }
    }, {
      key: "pickupLocation",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.pickupLocation))]
      }
    }, {
      key: "stuffingLocation",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.stuffingLocation))]
      }
    }, {
      key: "handoverLocation",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.handoverLocation))]
      }
    }, {
      key: "MyvehicleReleaseDate",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.MyvehicleReleaseDate))]
      }
    }, {
      key: "GRNSeries",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.GRNSeries))]
      }
    }, {
      key: "GRDate",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.GRDate))]
      }
    }, {
      key: "numberDays",
      fn: function(row1) {
        return [_vm._v(_vm._s(row1.item.numberDays))]
      }
    }])
  }) : _vm._e()], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "DailyIdelVehicleList--modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Daily Idle Details"
    }
  }, [_c('div', {
    staticClass: "d-block"
  }, [_c('b-row', [_c('b-col', [_c('h3', [(_vm.DailyIdelVehicleList.length > 0) ? _c('span', [_vm._v(_vm._s(_vm.ChangeDateFormat(_vm.DailyIdelVehicleList[0]["created_at"])) + "\n                ")]) : _vm._e()]), _vm._v(" "), (_vm.DailyIdelVehicleList.length == 0) ? _c('h3', [_vm._v("\n                Data Not Found !\n              ")]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "text-align": "end"
    }
  }, [(_vm.DailyIdelVehicleList.length > 0) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "disabled": _vm.ExportExcelBtnName != 'Export As Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getCustomIdelVehicleList(
          'DailyIdelVehicleList_SCREEN',
          '', 'Export As Excel'
        )
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExportExcelBtnName) + "\n                "), (_vm.ExportExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(_vm.DailyIdelVehicleList.length > 0) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Vehical NO.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                    Last Assignment No.\n                  ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Client")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Location")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                    Vehicle Release Date\n                  ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("GR No.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("GR Date.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Idle Days")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.DailyIdelVehicleList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mainSalesSeries))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.clientName))]), _vm._v(" "), _c('td', [_vm._v("\n                    Pickup : " + _vm._s(item.pickupLocation)), _c('br'), _vm._v("\n                    Stuffing : " + _vm._s(item.stuffingLocation)), _c('br'), _vm._v("\n                    Handover : " + _vm._s(item.handoverLocation)), _c('br')]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.MyvehicleReleaseDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.GRNSeries))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.GRDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.numberDays))])])
  })], 2)])])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticClass: "text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideDailyIdelVehicleList
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "DailyVehicleList--modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.viewType + ' Details'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('h3', [(
    _vm.DailyBookedVehicleList.length > 0 ||
    _vm.DailyTotalVehicleList.length > 0 ||
    _vm.DailyAvilableVehicleList.length > 0 ||
    _vm.DailyInactiveVehicleList.length > 0
  ) ? _c('span', [_vm._v(_vm._s(_vm.TodayDate) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "text-align": "end"
    },
    attrs: {
      "cols": "3"
    }
  }, [(
    _vm.DailyBookedVehicleList.length > 0 ||
    _vm.DailyTotalVehicleList.length > 0 ||
    _vm.DailyAvilableVehicleList.length > 0 ||
    _vm.DailyInactiveVehicleList.length > 0
  ) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "disabled": _vm.ExportExcelBtnName != 'Export As Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getCustomIdelVehicleListXLSX(
          'DailyIdelVehicleList_SCREEN',
          '', 'Export As Excel'
        )
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.ExportExcelBtnName) + "\n            "), (_vm.ExportExcelBtnName != 'Export As Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.DailyBookedVehicleList.length > 0 ? _vm.DailyBookedVehicleList : _vm.DailyTotalVehicleList,
      "fields": _vm.DailyBookedVehicleList.length > 0 ? _vm.ModalTotalBooking : _vm.ModalTotalVehicle,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "sr_no",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: _vm.DailyBookedVehicleList.length > 0 ? 'GRvehicleNo' : 'regdNo',
      fn: function(row1) {
        return [(_vm.DailyBookedVehicleList.length > 0) ? _c('span', [_vm._v("\n              " + _vm._s(row1.item.GRvehicleNo) + "\n            ")]) : _c('span', [_vm._v(_vm._s(row1.item.regdNo))])]
      }
    }, {
      key: _vm.DailyBookedVehicleList.length > 0 ? 'mainSalesSeries' : 'status',
      fn: function(row2) {
        return [(_vm.DailyBookedVehicleList.length > 0) ? _c('span', [_vm._v("\n              " + _vm._s(row2.item.mainSalesSeries) + "\n            ")]) : _c('span', [(
          row2.item.isTruckMasterActive == '1' &&
          row2.item.vehicleActiveInactiveId == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v("Available")])], 1) : _vm._e(), _vm._v(" "), (
          row2.item.isTruckMasterActive == '0' &&
          row2.item.vehicleActiveInactiveId == '1'
        ) ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("Booked")])], 1) : _vm._e(), _vm._v(" "), (row2.item.vehicleActiveInactiveId == '2') ? _c('h6', [_c('b-badge', {
          attrs: {
            "variant": "dark"
          }
        }, [_vm._v("INACTIVE")])], 1) : _vm._e()])]
      }
    }, {
      key: _vm.DailyBookedVehicleList.length > 0 ? 'clientName' : 'vehicleType',
      fn: function(row3) {
        return [(_vm.DailyBookedVehicleList.length > 0) ? _c('span', [_vm._v(_vm._s(row3.item.clientName))]) : _c('span', [_vm._v(_vm._s(row3.item.vehicleType))])]
      }
    }, {
      key: _vm.DailyBookedVehicleList.length > 0 ? 'pickupLocation' : 'engineNo',
      fn: function(row4) {
        return [(_vm.DailyBookedVehicleList.length > 0) ? _c('span', [_vm._v("\n              Pickup : " + _vm._s(row4.item.pickupLocation)), _c('br'), _vm._v("\n              Stuffing : " + _vm._s(row4.item.stuffingLocation)), _c('br'), _vm._v("\n              Handover : " + _vm._s(row4.item.handoverLocation)), _c('br')]) : _c('span', [_vm._v(_vm._s(row4.item.engineNo))])]
      }
    }, {
      key: _vm.DailyBookedVehicleList.length > 0 ? 'MyvehicleReleaseDate' : 'chassisNo',
      fn: function(row5) {
        return [(_vm.DailyBookedVehicleList.length > 0) ? _c('span', [_vm._v(_vm._s(row5.item.MyvehicleReleaseDate))]) : _c('span', [_vm._v(_vm._s(row5.item.chassisNo))])]
      }
    }, {
      key: _vm.DailyBookedVehicleList.length > 0 ? 'GRNSeries' : 'modNo',
      fn: function(row6) {
        return [(_vm.DailyBookedVehicleList.length > 0) ? _c('span', [_vm._v(_vm._s(row6.item.GRNSeries))]) : _c('span', [_vm._v(_vm._s(row6.item.modNo))])]
      }
    }, {
      key: _vm.DailyBookedVehicleList.length > 0 ? 'GRDate' : 'driverName',
      fn: function(row7) {
        return [(_vm.DailyBookedVehicleList.length > 0) ? _c('span', [_vm._v(_vm._s(row7.item.GRDate))]) : _c('span', [_vm._v(_vm._s(row7.item.driverName))])]
      }
    }])
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    staticClass: "text-center"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.hideDailyVehicleDeatils
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63bcf0b3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/DailyVehicleTrack.vue
// module id = 2683
// module chunks = 0